module.exports = __webpack_public_path__ + "img/random.8573254b.png";